import * as React from "react";
import {
    Create,
    Datagrid,
    Edit,
    EditButton,
    List,
    ReferenceInput,
    SelectInput,
    BooleanInput,
    FunctionField,
    TextField,
    TabbedForm,
    FormTab,
    DateInput,
    TextInput,
    useRecordContext,
    AutocompleteInput,
    useGetIdentity,
    BooleanField,
    TopToolbar,
    CreateButton,
    ExportButton,
    useCreate,
    useNotify,
    NumberInput, useRefresh, RadioButtonGroupInput,
} from 'react-admin';
import {Button, ButtonGroup, LinearProgress} from "@material-ui/core";
import {useReducer, useState} from "react";
import {Button as ButtonRA} from "ra-ui-materialui/lib/button";
import AddToPhotosIcon from "@material-ui/icons/AddToPhotos";
import {
    required,
    SaveButton,
    FormWithRedirect
} from 'react-admin';
import IconCancel from '@material-ui/icons/Cancel';

import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import DialogActions from '@material-ui/core/DialogActions';
import axios from "axios";
import {SERVER_URL} from "../../utils";
import DownloadIcon from '@mui/icons-material/Download';
import {getFilePlugin} from "@react-pdf-viewer/get-file";
import {printPlugin} from "@react-pdf-viewer/print";
import {ProgressBar, Viewer} from "@react-pdf-viewer/core";
import {BarLoader} from "react-spinner-animated";

const ProductLinkField = (props) => {
    const record = useRecordContext(props);
    if (record.productPARNumber == null) return "NON ASSEGNATO";
    return record.productPARNumber ?
        <a href={"#/product/" + record.productPARNumber.id}>{record.productPARNumber.id}</a> : "";
}

const postFilters = [
    <TextInput source="q" label="Cerca" alwaysOn/>,
];

const LabelSelect = choice => {
    return <span><img src={choice.img} style={{
        width: "50%"
    }
    } alt={choice.name}/></span>;
}

const PrintLabel = (props) => {
    const record = useRecordContext(props);
    const [labelPDFURL, setLabelPDFURL] = useState("");

    const [showDialog, setShowDialog] = useState(false);
    const getFilePluginInstance = getFilePlugin();
    const [printPluginInstance] = useState(printPlugin());
    const {DownloadButton} = getFilePluginInstance;
    const {Print} = printPluginInstance;

    const handleClick = async () => {
        fetch( SERVER_URL + "/api/v1/merchandise/download_single_label/" + record.colorcode.id + "/", {
            method: "GET",
            credentials: 'include'
        }).then((res) => {
            return res.text();
        }).then((data) => {
            console.log(data);
            const labelPDF = base64toBlob(data);
            if (labelPDF)
                setLabelPDFURL(URL.createObjectURL(labelPDF));
            setShowDialog(true);
        });
    }

    return (
        <>
            <ButtonRA onClick={handleClick}>
                <DownloadIcon/>
            </ButtonRA>
            <Dialog
                fullWidth
                open={showDialog}
                onClose={() => setShowDialog(false)}
            >
                <DialogTitle>Visualizza Etichetta</DialogTitle>
                <div
                    style={{
                        border: '1px solid rgba(0, 0, 0, 0.3)',
                        height: window.innerHeight,
                    }}
                >
                    <div style={{display: "flex", justifyContent: "center"}}>
                        <Print/>
                        <DownloadButton/>
                    </div>
                    {labelPDFURL && <Viewer fileUrl={labelPDFURL}
                                            plugins={[printPluginInstance, getFilePluginInstance]}
                                            renderLoader={(percentages) => (
                                                <div>
                                                    <ProgressBar progress={Math.round(percentages)}/>
                                                </div>
                                            )}
                    />}
                </div>
            </Dialog>
        </>);
}

const base64toBlob = (data) => {
        // Cut the prefix `data:application/pdf;base64` from the raw base 64
        if (!data) return null;
        const base64WithoutPrefix = data.substr('data:application/pdf;base64,'.length);

        const bytes = atob(base64WithoutPrefix);
        let length = bytes.length;
        let out = new Uint8Array(length);

        while (length--) {
            out[length] = bytes.charCodeAt(length);
        }

        return new Blob([out], {type: 'application/pdf'});
    }
;

const ToolbarButtons = () => {
    return (
        <>
            <TopToolbar>
                <CreateButton label={"Nuovo"}/>

                {/* <ExportButton label={"Esporta"}/> */}
            </TopToolbar>
        </>
    );
}

export const MerchandiseList = (props) => {
    const {loaded, identity, loading: identityLoading} = useGetIdentity();
    if (identityLoading) return <BarLoader text={"Caricamento..."}
                                   center={true}/>;

    if (!loaded) {
        return null;
    }

    return (
        <List {...props} perPage={25} filters={postFilters} empty={<ToolbarButtons/>} actions={<ToolbarButtons/>}>
            <Datagrid rowClick="">
                <ProductLinkField source="productPARNumber" label="Prodotto"/>
                <TextField source="lot" label="Lotto del prodotto"/>
                <FunctionField label="ID ColorCode"
                               render={record => record.colorcode ? record.colorcode.id : ""}/>
                {/*<ImageField source="colorcode.colorCodeImg" label="ColorCode"/>*/}
                <FunctionField label="Data inizio Garanzia"
                               render={record => `${new Date(...record.warrantyDepartureDate).toLocaleDateString("it-IT")}`}/>
                <BooleanField label="Garanzia Attiva" source="activeWarranty"/>
                <PrintLabel identity={identity}/>
                <EditButton label="Modifica"/>
            </Datagrid>
        </List>
    );
}

export const MerchandiseCreate = (props) => {
    return (
        <Create {...props}>
            <TabbedForm>
                <FormTab label={"Prodotto"}>
                    <TextInput source="id" label="Codice Identificativo" initialValue={uuidv4()} disabled={true}/>
                    <TextInput source="lot" label="Numero di lotto"/>
                    <ReferenceInput source="productPARNumber.id" reference="product" label="PAR Number prodotto"
                                    sort={{field: 'productName', order: 'ASC'}}>
                        <AutocompleteInput optionText="productName"/>
                    </ReferenceInput>
                    <DateInput source={"productionDate"} defaultValue={new Date()} label={"Data Produzione"}/>
                </FormTab>
                <FormTab label={"Garanzia"}>
                    <BooleanInput label="Garanzia Attiva" source="activeWarranty"/>
                    <ReferenceInput source="warranty.id" reference="warranty" label="Garanzia">
                        <SelectInput optionText="description" disableValue="not_available"/>
                    </ReferenceInput>
                    <DateInput source={"warrantyDepartureDate"} defaultValue={new Date()}
                               label={"Data Inzio Garanzia"}/>
                    <DateInput source={"installationDate"} defaultValue={new Date()} label={"Data Installazione"}/>
                </FormTab>
            </TabbedForm>
        </Create>
    );
}

const uuidv4 = () => {
    return ([1e7] + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, c =>
        (c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> c / 4).toString(16)
    );
}

export const MerchandiseEdit = (props) => (
    <Edit {...props}>
        <TabbedForm>
            <FormTab label={"Prodotto"}>
                <TextInput disabled source="id" label="Codice Identificativo"/>
                <TextInput hidden disabled source="productPARNumber.manufacturerCode.createdBy.id" label="Codice Identificativo"/>
                <TextInput source="lot" label="Numero di lotto"/>
                <ReferenceInput source="productPARNumber.id" reference="product" label="PAR Number prodotto"
                                sort={{field: 'productName', order: 'ASC'}}>
                    <AutocompleteInput optionText="productName"/>
                </ReferenceInput>
                <DateInput source={"productionDate"} label={"Data Produzione"}/>
            </FormTab>
            <FormTab label={"Garanzia"}>
                <BooleanInput label="Garanzia Attiva" source="activeWarranty"/>
                <ReferenceInput source="warranty.id" reference="warranty" label="Garanzia">
                    <SelectInput optionText="description" disableValue="not_available"/>
                </ReferenceInput>
                <DateInput source={"warrantyDepartureDate"} label={"Data Inzio Garanzia"}/>
                <DateInput source={"installationDate"} label={"Data Installazione"}/>
            </FormTab>
        </TabbedForm>
    </Edit>
);